// spinnerService.ts
let showSpinnerCallback: () => void = () => {};
let hideSpinnerCallback: () => void = () => {};

export const setSpinnerCallbacks = (show: () => void, hide: () => void) => {
  showSpinnerCallback = show;
  hideSpinnerCallback = hide;
};

export const showSpinner = () => {
  showSpinnerCallback();
};

export const hideSpinner = () => {
  hideSpinnerCallback();
};
